require('./_product-tabs');
require('./_product-tab-additional-information');
require('./_product-tab-description');

(function () {
    "use strict";

    const scrollToTab = function (panelSelector) {
        const targetPanel = document.querySelector(panelSelector);
        if (targetPanel) {
            setTimeout(() => {
                const adminbar = document.getElementById('wpadminbar');
                const tabsUl = document.querySelector('.woocommerce-tabs ul.wc-tabs');
                const tabsHeight = tabsUl ? tabsUl.offsetHeight : 0;
                const rect = targetPanel.getBoundingClientRect();
                let finalScrollTop = rect.top + window.scrollY - tabsHeight;
                if (adminbar) {
                    finalScrollTop -= adminbar.offsetHeight;
                }
                window.scrollTo({
                    top: finalScrollTop - 50,
                    behavior: 'smooth'
                });
            }, 100);
        }
    };

    document.addEventListener('click', function (e) {
        // Excerpt see-more trigger
        const seeMore = e.target.closest('.woocommerce-product-details__short-description .excerpt-trigger--see-more');
        if (seeMore) {
            const parent = seeMore.closest('.woocommerce-product-details__short-description');
            if (parent) {
                const content = parent.querySelector('.product-excerpt-content');
                if (content) content.classList.remove('cropped');
                const hideTrigger = parent.querySelector('.excerpt-trigger--hide');
                if (hideTrigger) hideTrigger.style.display = 'block';
            }
            seeMore.style.display = 'none';
            return;
        }

        // Excerpt hide trigger
        const hideTrigger = e.target.closest('.woocommerce-product-details__short-description .excerpt-trigger--hide');
        if (hideTrigger) {
            const parent = hideTrigger.closest('.woocommerce-product-details__short-description');
            if (parent) {
                const content = parent.querySelector('.product-excerpt-content');
                if (content) content.classList.add('cropped');
                const seeMore = parent.querySelector('.excerpt-trigger--see-more');
                if (seeMore) seeMore.style.display = 'block';
            }
            hideTrigger.style.display = 'none';
            return;
        }

        // Quick View modal trigger
        const qvBtn = e.target.closest(".product-quick-view-action:not(.disabled)");
        if (qvBtn) {
            e.preventDefault();
            const modalEl = document.querySelector(".product-quick-view-modal");
            if (modalEl) {
                qvBtn.classList.add("disabled");
                const loading = modalEl.querySelector(".modal-content .loading");
                const content = modalEl.querySelector(".modal-content .content");
                const title = modalEl.querySelector(".modal-title");
                if (loading) loading.style.display = 'block';
                if (content) content.innerHTML = "";
                if (title) title.innerHTML = "";

                if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                    const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                    modal.show();
                }

                const params = new URLSearchParams();
                params.append('action', 'negarshop_quick_view_ajax');
                params.append('id', qvBtn.getAttribute("data-id") || '');

                fetch(NS_OBJ.ajax_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params
                })
                .then(res => res.json())
                .then(response => {
                     if (response.success) {
                         if (loading) loading.style.display = 'none';
                         if (content) content.innerHTML = response.data.html;
                         if (title) title.innerHTML = response.data.title;
                         qvBtn.classList.remove("disabled");

                         document.querySelectorAll('.swiper[data-settings]').forEach(el => {
                             el.dispatchEvent(new CustomEvent('init_carousel', { bubbles: true }));
                         });

                         if (typeof window.initVariationForm !== "undefined"){
                             window.initVariationForm(content);
                         }
                     }
                })
                .catch(err => {
                    console.error(err);
                    qvBtn.classList.remove("disabled");
                });
            }
            return;
        }

        // Additional information tab trigger
        const viewAllAttrs = e.target.closest(".product-featured-attributes .view-all-attributes a");
        if (viewAllAttrs) {
            e.preventDefault();
            const targetTab = document.querySelector("#tab-title-additional_information a");
            if (targetTab) {
                if (window.jQuery) window.jQuery(targetTab).trigger('click');
                else targetTab.click();
                scrollToTab("#tab-additional_information");
            }
            return;
        }

        // Reviews tab trigger
        const viewAllReviews = e.target.closest('.product-comments-meta a[href="#tab-reviews"]');
        if (viewAllReviews) {
            e.preventDefault();
            const targetTab = document.querySelector("#tab-title-reviews a");
            if (targetTab) {
                if (window.jQuery) window.jQuery(targetTab).trigger('click');
                else targetTab.click();
                scrollToTab("#tab-reviews");
            }
            return;
        }

        // Questions tab trigger
        const viewAllQuestions = e.target.closest('.product-comments-meta a[href="#tab-questions"]');
        if (viewAllQuestions) {
            e.preventDefault();
            const targetTab = document.querySelector("#tab-title-questions a");
            if (targetTab) {
                if (window.jQuery) window.jQuery(targetTab).trigger('click');
                else targetTab.click();
                scrollToTab("#tab-questions");
            }
            return;
        }

        // Custom Swatch option selection click
        const option = e.target.closest('.negarshop-term-option:not(.disabled)');
        if (option) {
            e.preventDefault();
            const value = option.getAttribute('data-value');
            const valueCol = option.closest('.value');
            if (valueCol) {
                const select = valueCol.querySelector('select');
                if (select) {
                    if (option.classList.contains('selected')) {
                        select.value = '';
                    } else {
                        select.value = value;
                    }
                    if (window.jQuery) {
                        window.jQuery(select).trigger('change');
                    } else {
                        select.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            }
            return;
        }
    });

    document.addEventListener("submit", function (e) {
        const surveyForm = e.target.closest("#product-survey-form");
        if (surveyForm) {
            e.preventDefault();
            if (document.body.classList.contains("logged-in")) {
                const formData = new FormData(surveyForm);
                const params = new URLSearchParams();
                formData.forEach((value, key) => {
                    params.append(key, value);
                });
                params.append("action", "negarshop_product_survey_ajax");
                params.append("answ", "no");

                if (params.get("desc1") || params.get("desc2")) {
                    surveyForm.classList.add("loading");
                    fetch(NS_OBJ.ajax_url, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: params
                    })
                    .then(res => res.json())
                    .then(response => {
                        surveyForm.classList.remove("loading");
                        if (response.status) {
                            const modalEl = document.getElementById("product-survey");
                            if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                                const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                                modal.hide();
                            }
                            surveyForm.remove();
                            const surveyWidget = document.querySelector(".entry-summary .product-survey");
                            if (surveyWidget) surveyWidget.classList.add("sent");
                        } else {
                            if (window.jQuery && typeof window.jQuery.notify === 'function') {
                                window.jQuery.notify({ message: response.data }, { type: "error", z_index: 9999 });
                            } else {
                                alert(response.data);
                            }
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        surveyForm.classList.remove("loading");
                    });
                }
            } else {
                const accountWidget = document.querySelector(".header-account");
                const isPopupEnabled = accountWidget && accountWidget.classList.contains("pop-up-login");
                if (isPopupEnabled) {
                    const modalEl = document.getElementById("login-popup-modal");
                    if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                        const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                        modal.show();
                    }
                } else {
                    const accountLink = document.querySelector(".header-account .box-inner");
                    window.location.href = accountLink ? accountLink.getAttribute("href") : "/my-account/";
                }
            }
            return;
        }
    });

    document.addEventListener("click", function (e) {
        const yesBtn = e.target.closest(".product-survey .btn.yes");
        if (yesBtn) {
            e.preventDefault();
            if (document.body.classList.contains("logged-in")) {
                const parent = yesBtn.closest(".product-survey");
                if (parent) parent.classList.add("loading");

                const params = new URLSearchParams();
                params.append("action", "negarshop_product_survey_ajax");
                params.append("answ", "yes");
                params.append("product", yesBtn.getAttribute("data-product") || '');

                fetch(NS_OBJ.ajax_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params
                })
                .then(res => res.json())
                .then(response => {
                    if (parent) parent.classList.remove("loading");
                    if (response.status) {
                        if (parent) parent.classList.add("sent");
                    } else {
                        if (window.jQuery && typeof window.jQuery.notify === 'function') {
                            window.jQuery.notify({ message: response.data }, { type: "error", z_index: 9999 });
                        } else {
                            alert(response.data);
                        }
                    }
                })
                .catch(err => {
                    console.error(err);
                    if (parent) parent.classList.remove("loading");
                });
            } else {
                const accountWidget = document.querySelector(".header-account");
                const isPopupEnabled = accountWidget && accountWidget.classList.contains("pop-up-login");
                if (isPopupEnabled) {
                    const modalEl = document.getElementById("login-popup-modal");
                    if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                        const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                        modal.show();
                    }
                } else {
                    const accountLink = document.querySelector(".header-account .box-inner");
                    window.location.href = accountLink ? accountLink.getAttribute("href") : "/my-account/";
                }
            }
        }
    });

    document.addEventListener('DOMContentLoaded', function () {
        // Excerpt triggers initially
        const excerptTrigger = document.querySelector('.woocommerce-product-details__short-description .excerpt-trigger--see-more');
        if (excerptTrigger) {
            const parent = excerptTrigger.closest('.woocommerce-product-details__short-description');
            const wrapper = parent ? parent.querySelector('.product-excerpt-content') : null;
            if (wrapper) {
                wrapper.classList.add('cropped');
                if (wrapper.offsetHeight >= wrapper.scrollHeight) {
                    wrapper.classList.remove('cropped');
                    excerptTrigger.style.display = 'none';
                }
            }
        }

        // Swatch background color assignments
        document.querySelectorAll('.negarshop-color-swatch').forEach(el => {
            const color = el.getAttribute('data-color');
            if (color) el.style.backgroundColor = color;
        });

        // Swatch background image assignments
        document.querySelectorAll('.negarshop-image-swatch').forEach(el => {
            const bg = el.getAttribute('data-bg');
            if (bg) el.style.backgroundImage = 'url(' + bg + ')';
        });

        // Listen for WooCommerce Core events using jQuery triggers since WooCommerce relies on them
        if (window.jQuery) {
            window.jQuery(document.body).on('woocommerce_variation_has_changed', function () {
                document.querySelectorAll('.negarshop-term-options').forEach(container => {
                    const valueEl = container.closest('.value');
                    const select = valueEl ? valueEl.querySelector('select') : null;
                    const parentTr = container.closest('tr');
                    const label = parentTr ? parentTr.querySelector('.label label') : null;

                    if (label) {
                        if (!label.querySelector('span.selected')) {
                            const text = label.textContent;
                            label.innerHTML = '<span class="label-text">' + text + '</span><span class="selected"></span>';
                        }
                        const selectedLabel = label.querySelector('.selected');

                        if (select) {
                            const val = select.value;
                            container.querySelectorAll('.negarshop-term-option').forEach(opt => opt.classList.remove('selected'));
                            if (val) {
                                const activeOpt = container.querySelector('.negarshop-term-option[data-value="' + val + '"]');
                                if (activeOpt) activeOpt.classList.add('selected');
                            }
                            if (val.trim().length) {
                                const selectedOption = select.querySelector('option[value="' + val + '"]');
                                if (selectedLabel && selectedOption) selectedLabel.textContent = selectedOption.textContent;
                            } else {
                                if (selectedLabel) selectedLabel.textContent = '';
                            }

                            // Sync enabled status based on available variation options
                            container.querySelectorAll('.negarshop-term-option').forEach(opt => opt.classList.add('disabled'));
                            select.querySelectorAll('option').forEach(opt => {
                                const optVal = opt.value;
                                if (optVal) {
                                    const matchingOpt = container.querySelector('.negarshop-term-option[data-value="' + optVal + '"]');
                                    if (matchingOpt) matchingOpt.classList.remove('disabled');
                                }
                            });
                        }
                    }
                });
            });

            // Initial variations sync
            setTimeout(function () {
                window.jQuery(document.body).trigger('woocommerce_variation_has_changed');
            }, 100);

            // Variation timer listener
            const saleTimer = document.querySelector('.product-sale-timer');
            if (saleTimer) {
                const timerContent = saleTimer.querySelector('.counter-content');
                const initialSaleTimerHTML = timerContent ? timerContent.innerHTML : '';
                const initialSaleTimerVisible = !saleTimer.classList.contains('d-none');

                window.jQuery(document).on('found_variation', 'form.variations_form', function (event, variation) {
                    if (variation && variation.has_sale_timer) {
                        if (timerContent) timerContent.innerHTML = variation.variation_sale_html;
                        saleTimer.classList.remove('d-none');
                        const countdownEl = saleTimer.querySelector('.negarshop-countdown');
                        if (countdownEl) {
                            countdownEl.dispatchEvent(new CustomEvent('init', { bubbles: true }));
                        }
                    } else {
                        saleTimer.classList.add('d-none');
                    }
                });

                window.jQuery(document).on('reset_data', 'form.variations_form', function () {
                    if (initialSaleTimerVisible) {
                        if (timerContent) timerContent.innerHTML = initialSaleTimerHTML;
                        saleTimer.classList.remove('d-none');
                        const countdownEl = saleTimer.querySelector('.negarshop-countdown');
                        if (countdownEl) {
                            countdownEl.dispatchEvent(new CustomEvent('init', { bubbles: true }));
                        }
                    } else {
                        saleTimer.classList.add('d-none');
                    }
                });
            }
        }
    });

})();
